import React, { useEffect, useState } from 'react';
import { useLoadScript } from './MortyScript';

export const Recommendation: React.FC<{
  customerId: string;
}> = ({ customerId }) => {
  const [isMortyWidgetLoaded, setIsMortyWidgetLoaded] = useState(false);

  const { startMorty } = useLoadScript();

  useEffect(() => {
    if (!isMortyWidgetLoaded && customerId) {
      setIsMortyWidgetLoaded(true);
      startMorty(customerId);
    }
  }, [isMortyWidgetLoaded, customerId]);

  return <div id="morty-iq-container" />;
};
